export default __webpack_public_path__ + "static/media/offline.483023d9.svg";